// extracted by mini-css-extract-plugin
export default {"button":"dm-z","reviewSort":"em-z"};